const PAGE_TITLE = "Sales";

export { PAGE_TITLE };
